import { nameof } from 'ts-simple-nameof'
import { SelectorOrNestedKey } from './types'

export const selectorOrNestedKeyToKey = (selector: SelectorOrNestedKey<any>): string => {
  const entityKey = typeof selector === 'string' ? selector : nameof(selector)
  return entityKey
}
